module.exports = __webpack_public_path__ + "img/ic_american_express.bc044eee.png";